import axios from 'api/axios'
import { useEffect, useState } from 'react'

const useFetchSolicitudesPendientes = ({ enabled = true } = {}) => {
  const [response, setResponse] = useState([])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const fetchData = () => {
    if (loading) {
      return
    }

    setLoading(true)
    axios
      .get(`/solicitudespendientes`)
      .then((request_response) => {
        const data = request_response.data
        setResponse(data)
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (!enabled) return
    fetchData()
  }, [enabled])

  return { response, error, loading }
}

export default useFetchSolicitudesPendientes
